<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M23.15 7.35c-.61-1.47-1.46-2.82-2.56-3.92s-2.44-1.96-3.9-2.57C15.23.37 13.64 0 12.06 0S8.89.24 7.43.86s-2.8 1.47-3.9 2.57C2.31 4.53 1.46 5.88.85 7.23.37 8.69 0 10.29 0 11.88c0 3.18 1.22 6.24 3.65 8.57C5.85 22.78 8.89 24 12.06 24s6.21-1.35 8.41-3.55C22.78 18.24 24 15.18 24 12c0-1.59-.24-3.18-.85-4.65z"
    />
    <path
      class="check"
      fill="#fff"
      d="M17.66 5.91c-.12-.11-.23-.11-.46-.23h-.46c-.11 0-.34.11-.46.11l-.34.34-6.63 8.84-2.74-2.76c-.23-.21-.57-.32-.91-.32-.34 0-.69.11-.91.34s-.35.57-.35.92.11.69.34.92l3.77 3.68c.11.11.23.23.46.34.11.11.34.11.57.11s.34-.11.46-.11c.11-.11.34-.23.46-.34l7.43-10.11c.11-.12.11-.23.22-.46v-.46c0-.12-.11-.35-.11-.46-.11-.12-.23-.35-.34-.35z"
    />
  </svg>
</template>
